import {type AppLanguage} from 'platform/locale';

/**
 * A tick-sized number in the customer's language: "15 tis." (cs, sk), "15 tys." (pl), "15K" (en, it,
 * nl), "15 k" (fr), "15 mil" (es), "15.000" (de). The locale data decides the abbreviation, so no
 * translation key is needed. It calls `Intl.NumberFormat` directly because `platform/locale` has no
 * compact notation, so the tenant's number separators do not apply to these tick labels.
 */
export const formatCompactNumber = (language: AppLanguage, value: number) =>
  new Intl.NumberFormat(language, {notation: 'compact'}).format(value);
